<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref, computed, onMounted } from "vue"
import { usePayment, paymentManager } from "@/composables/usePayment"
import NBFormSelect from "@/app/Checkout/components/common/NBFormSelect/index.vue"

const props = defineProps({
  banks: {
    type: Array,
    default: () => [],
  },
})

const selectedbank = ref(null)
const { proceedToPayment } = usePayment()
const bankOptions = computed(() => props.banks.map(bank => ({ label: bank.name, value: bank.id })))

const init = () => {
  const payload = selectedbank.value !== null ? { selected_online_bank: selectedbank.value.value } : {}
  return proceedToPayment(payload)
}

onMounted(() => {
  paymentManager.register({
    init,
  })
})
</script>
